import useCurrentUser from '~/client/hooks/user/useCurrentUser';

const useWalletCurrency = () => {
  const { walletCurrency = 'BTC' } = useCurrentUser();
  return walletCurrency;
};

export default useWalletCurrency;
